import React from 'react'
import { Alert as AntAlert } from 'antd'

type AlertType = 'success' | 'info' | 'warning' | 'error'

const allowedTypes: AlertType[] = ['success', 'info', 'warning', 'error']
const [TYPE_SUCCESS] = allowedTypes

interface AlertProps {
  type?: AlertType
  message: string
  onDismiss?: () => void
}

const Alert: React.FC<AlertProps> = ({ type = TYPE_SUCCESS, message, onDismiss }) => (
  <AntAlert
    message={message}
    type={type}
    closable={!!onDismiss}
    onClose={onDismiss}
    showIcon
  />
)

export default Alert
